import { useState, useEffect } from "react";
import { produce } from "immer";

const Childrens = ({ value = [], onChange = () => {}, no_of_children }) => {
  const [state, setState] = useState(value);

  useEffect(() => {
    onChange(state);
  }, [state]);

  const handleChange = (index, key, value) => {
    const draftState = produce(state, (draft) => {
      if (draft[index]) {
        draft[index][key] = value;
      } else {
        draft[index] = { [key]: value };
      }
    });
    setState(draftState);
  };

  return (
    <>
      {no_of_children > 0 && (
        <div className="children_fields_wrapper">
          {[...Array(Math.abs(no_of_children || 0))].length &&
            [...Array(Math.abs(no_of_children || 0))].map((item, index) => {
              return (
                <div key={index} className="form_field field_text full_width">
                  <input type="text" className="input_text" placeholder="Children Name" value={state[index]?.name} onChange={(e) => handleChange(index, "name", e.target.value)} />
                </div>
              );
            })}
        </div>
      )}
    </>
  );
};

export default Childrens;
